import { Link } from "react-router-dom";
// Uses global.css design system

type LegacyInfoVariant = "events" | "about" | "support" | "contact";

const contentByVariant: Record<LegacyInfoVariant, { title: string; intro: string; cards: Array<{ title: string; body: string }> }> = {
  events: {
    title: "Events & Workshops",
    intro: "Attend satsangs, guided intensives, and seasonal gatherings designed for practical transformation.",
    cards: [
      { title: "Weekly Satsang", body: "A live community session for reflection, wisdom, and mindful discussion." },
      { title: "Meditation Intensive", body: "Deepen concentration and stillness with structured daily guidance." },
      { title: "Teacher Circle", body: "Mentorship sessions for facilitators and advanced practitioners." },
    ],
  },
  about: {
    title: "About Aekam",
    intro: "A modern spiritual platform integrating wisdom, daily practice, and conscious commerce.",
    cards: [
      { title: "Mission", body: "Make ancient teachings actionable for contemporary life and wellbeing." },
      { title: "Approach", body: "Blend contemplative practice, reflective learning, and measurable progress." },
      { title: "Community", body: "Support seekers with inclusive, respectful, and growth-oriented experiences." },
    ],
  },
  support: {
    title: "Support Us",
    intro: "Help us sustain free teachings and build high-quality tools for seekers worldwide.",
    cards: [
      { title: "Contribute", body: "Support platform development and content production through donations." },
      { title: "Volunteer", body: "Join events, moderation, and mentorship initiatives." },
      { title: "Partner", body: "Collaborate on wellness programs, workshops, and community outreach." },
    ],
  },
  contact: {
    title: "Contact Us",
    intro: "Reach the team for platform support, partnerships, and general guidance.",
    cards: [
      { title: "Support Desk", body: "For account and technical issues, we respond within one business day." },
      { title: "Partnerships", body: "Discuss events, brand collaborations, and program integrations." },
      { title: "Community Care", body: "Share feedback and help us improve the seeker experience." },
    ],
  },
};

export function LegacyInfoPage({ variant }: { variant: LegacyInfoVariant }) {
  const data = contentByVariant[variant];

  return (
    <>
      <section className="page-hero">
        <div className="container">
          <span className="eyebrow">Aekam</span>
          <h1 className="display-2 page-hero__title-spaced">{data.title}</h1>
          <p className="body-lg text-muted legacy-hero__body">{data.intro}</p>
          <div className="legacy-hero__actions">
            <Link to="/practice" className="btn btn--primary">Go to Practice</Link>
            <Link to="/wisdom" className="btn btn--outline">Explore Wisdom</Link>
          </div>
        </div>
      </section>

      <section className="section section--surface-alt">
        <div className="container">
          <div className="grid-3">
            {data.cards.map((card) => (
              <div key={card.title} className="feature-card">
                <h3 className="feature-card__title">{card.title}</h3>
                <p className="feature-card__body">{card.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
